import { createSelector } from 'reselect'

export const getFavouriteProfilesFetchedInitially = createSelector(
  state => state && state.user && state.user.profile && state.user.profile.favouriteProfiles
    ? state.user.profile.favouriteProfiles.fetchedInitially : false,
    fetchedInitially => fetchedInitially
)
